import React from 'react';
import SubmissionViewer from '../../components/admin/SubmissionViewer';

const CareerApplications = () => {
  const columns = [
    { key: 'job_title', label: 'Job Title', type: 'text' },
    { key: 'name', label: 'Applicant Name', type: 'text' },
    { key: 'email', label: 'Email', type: 'text' },
    { key: 'phone', label: 'Phone', type: 'text' },
    { key: 'resume_url', label: 'Resume', type: 'link' },
    { key: 'linkedin_url', label: 'LinkedIn', type: 'link' },
  ];

  return (
    <SubmissionViewer 
      tableName="career_applications" 
      title="All Career Applications" 
      columns={columns} 
    />
  );
};

export default CareerApplications;
